import { render, staticRenderFns } from "./BlogsGrid.vue?vue&type=template&id=2865cf81&scoped=true&"
import script from "./BlogsGrid.vue?vue&type=script&lang=js&"
export * from "./BlogsGrid.vue?vue&type=script&lang=js&"
import style0 from "./BlogsGrid.vue?vue&type=style&index=0&id=2865cf81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865cf81",
  null
  
)

export default component.exports